import {createFileRoute, useSearch} from '@tanstack/react-router';
import SocialGames, {SocialTab} from '../../football/social/SocialGames';
import {useJwtAuth} from '../../JWTAuthProvider';

/**
 * A football player's view of their club's social games (football v2): Results, Table and Stats,
 * and New game only for someone who organizes the club. The club is the one auth/me names for
 * them (`football_club`): the club whose list they are on.
 */
export const Route = createFileRoute('/_app/social-games')({
    component: RouteComponent,
});

function RouteComponent() {
    const user: any = useJwtAuth().user;
    const search = useSearch({strict: false}) as {tab?: string};
    const club = user?.football_club as {uid: string; name: string; organizer: boolean} | null | undefined;
    const tab = (['new', 'results', 'table', 'stats'] as const).find((t) => t === search.tab) ?? 'results';
    return <SocialGames key={club?.uid ?? 'none'} initialTab={tab as SocialTab} clubUid={club?.uid} canRecord={!!club?.organizer} />;
}
